const companymemeberdata=[
    {
        id:1,
        name:'SOHAIL AHMAD',
        role:"General Manager",
        image:'./companyimages/sohail.jpg'
    },
    {
        id:2,
        name:'FAWAD KHAN',
        role:'Operational Manager',
        image:'./companyimages/fawad.jpg'
    },
    {
        id:3,
        name:'MINHAJ UDIN',
        role:"CEO of this Company ",
        image:'./companyimages/minhaj.jpg'
    },
  
   
]


export {
    companymemeberdata
}
